import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialProductStockFilterData,
  InitialProductStockFilterDataVariables
} from "./types/InitialProductStockFilterData";
import {
  ProductStocksDownload,
  ProductStocksDownloadVariables
} from "./types/ProductStocksDownload";
import {
  ProductStocksReport,
  ProductStocksReportVariables
} from "./types/ProductStocksReport";

export const productStockList = gql`
  ${pageInfoFragment}
  query ProductStocksReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: ProductStocksFilterInput!
  ) {
    productStocks(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          variant_id
          mall_name
          brand_name
          sku
          product_name
          variant_name
          availability_status
          quantity
          price_amount
          product_id
          is_simple_product
        }
      }
    }
  }
`;

export const useProductStocksQuery = makeBossQuery<
  ProductStocksReport,
  ProductStocksReportVariables
>(productStockList);

export const productStockDownload = gql`
  ${pageInfoFragment}
  query ProductStocksDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: ProductStocksFilterInput!
  ) {
    productStocks(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          tenant_id
          variant_id
          mall_name
          brand_name
          sku
          product_name
          variant_name
          quantity
          availability_status
          product_status
          price_amount
          updated_at
          is_simple_product
          product_id
          is_visible
          is_available
          track_inventory
          stock_updated_at
          vertical
          last_published_date
          last_unpublished_date
        }
      }
    }
  }
`;

export const useProductStocksDownload = makeBossQuery<
  ProductStocksDownload,
  ProductStocksDownloadVariables
>(productStockDownload);

export const initialProductStockFilterDataQuery = gql`
  query InitialProductStockFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialProductStockFilterDataQuery = makeQuery<
  InitialProductStockFilterData,
  InitialProductStockFilterDataVariables
>(initialProductStockFilterDataQuery);
